import { CardSection } from "../../../components/CardSection";
import { StyledSection7 } from "./style";
import { BarGraph } from "../../../components/Graph/BarGraph";
import { REGIONS } from "../../../consts/const";

export const Section7 = () => {
  const tempData = REGIONS.map((region) => ({
    departmentName: region.label,
    receivedData: 100,
  }));

  return (
    <StyledSection7>
      <div className="section7-container">
        <CardSection title="지킴이 연계율 (%)" icon="Histogram">
          <BarGraph
            data={tempData}
            xKey="departmentName"
            yKey={[{ label: "지킴이 연계율", key: "receivedData" }]}
            unit="%"
            showLabels={true}
          />
        </CardSection>
      </div>
    </StyledSection7>
  );
};
